// Choropleth colour palettes (S11 ramp editor). Each is a low→high ramp; the
// classifier samples as many stops as it needs. 'custom' is filled from prefs.
export const PALETTES = {
  default: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
  viridis: ['#440154', '#472d7b', '#3b528b', '#2c728e', '#21918c', '#28ae80', '#5ec962', '#addc30', '#fde725'],
  inferno: ['#000004', '#1b0c41', '#4a0c6b', '#781c6d', '#a52c60', '#cf4446', '#ed6925', '#fb9b06', '#fcffa4'],
  blues:   ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
  reds:    ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
  greens:  ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
  cividis: ['#00204c', '#193b6a', '#3b5573', '#5d6e72', '#7c8870', '#9da66f', '#c2c56e', '#e9e36a', '#ffffe0'],
}

export const PALETTE_KEYS = Object.keys(PALETTES)
export const PALETTE_LABELS = {
  default: 'Bleus', viridis: 'Viridis — daltonisme', inferno: 'Inferno — contraste',
  blues: 'Bleus', reds: 'Rouges', greens: 'Verts', cividis: 'Cividis — daltonisme',
}

const hexToRgb = (h) => {
  const n = parseInt(h.slice(1), 16)
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255]
}
const rgbToHex = (r, g, b) => `#${[r, g, b].map((v) => Math.round(v).toString(16).padStart(2, '0')).join('')}`

// Sample `count` evenly-spaced colours from a ramp (linear interpolation).
export const samplePalette = (ramp, count) => {
  if (count <= 1) return [ramp[ramp.length - 1]]
  const out = []
  for (let i = 0; i < count; i++) {
    const t = (i / (count - 1)) * (ramp.length - 1)
    const lo = Math.floor(t)
    const hi = Math.min(ramp.length - 1, lo + 1)
    const f = t - lo
    const a = hexToRgb(ramp[lo]); const b = hexToRgb(ramp[hi])
    out.push(rgbToHex(a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f, a[2] + (b[2] - a[2]) * f))
  }
  return out
}

export const resolvePalette = (key, customRamp) =>
  (key === 'custom' && customRamp?.length ? customRamp : (PALETTES[key] || PALETTES.default))
